<template>
  <v-item-group
    :value="value"
    mandatory
    class="zfp"
    @change="$emit('input', $event)"
  >
    <v-item
      v-for="f in formats"
      :key="f.value"
      v-slot="{ active, toggle }"
      :value="f.value"
    >
      <v-card
        outlined
        class="zfp-card"
        :class="{ active }"
        @click="toggle"
      >
        <div class="zfp-title">
          <v-icon small :color="active ? 'primary' : undefined">
            {{ active ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
          </v-icon>
          {{ f.title }}
        </div>
        <div class="zfp-text">
          {{ f.text }}
        </div>
      </v-card>
    </v-item>
  </v-item-group>
</template>

<script>
  import { KML_FORMATS } from '@/util/zonesKml'

  export default {
    name: 'ZoneFormatPicker',
    props: {
      value: { type: String, default: 'fakt' },
    },
    data: () => ({ formats: KML_FORMATS }),
  }
</script>

<style scoped>
.zfp {
  display: flex;
  gap: 10px;
}
.zfp-card {
  flex: 1;
  padding: 12px 14px;
  border-radius: 10px !important;
  border: 2px solid #e0e3e7 !important;
  cursor: pointer;
}
.zfp-card.active {
  border-color: #ff9100 !important;
}
.zfp-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 4px;
}
.zfp-text {
  font-size: 12px;
  line-height: 1.35;
  color: rgba(0, 0, 0, 0.6);
}
</style>
